/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Energy_LabelInputs */

const cs_enum_energy_label = /** @type {(inputs: Enum_Energy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Energetický štítek`)
};

const en_enum_energy_label = /** @type {(inputs: Enum_Energy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Energy label`)
};

/**
* | output |
* | --- |
* | "Energy label" |
*
* @param {Enum_Energy_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_energy_label = /** @type {((inputs?: Enum_Energy_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Energy_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_energy_label(inputs)
	return cs_enum_energy_label(inputs)
});